import { Component, OnInit } from '@angular/core';
import { QuotationService } from '../../services/quotation-service/quotation.service';
import { LeadService } from '../../services/lead-service/lead.service';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {

  fragment: string;
  recommendation: Boolean = false;

  constructor(public quotationService: QuotationService, private leadService: LeadService) { }

  ngOnInit() {
    this.fragment = this.leadService.fragment;
    if (this.leadService.crossSellRecommendation) {
      this.recommendation = true;
    }
  }
}
